<div>
  <app-alert
    style="margin-bottom: 32px"
    class="flex-col-container mb-8 mt-24"
    type="warning"
    icon="warning_amber"
    lineHeight="lh-1"
    [message]="'MODAL_CANCEL_ACC.ALERT' | translate"></app-alert>
  <p class="my-10">{{ 'MODAL_CANCEL_ACC.STATEMENT' | translate}}</p>

  <div class="p-16 flex-row-container items-center b-0-5 rounded">
    <img class="mr-8" src="assets/svg/account_exoneration.svg" alt="rappi logo" />
    <div class="flex-col-container start flex-1 ml-4">
      <span class="fw-500">{{ 'MODAL_CANCEL_ACC.ACCOUNT_NUMBER' | translate}}</span>
      <span>{{account?.external_number}}</span>
    </div>
    <app-read-only
      [descColor]="account?.status === STATUS.ENABLE ? 'success' : 'warning'"
      [applyBorderBottom]="false"
      [value]="account?.status"></app-read-only>
  </div>

  <form class="w-95 m-auto" [formGroup]="cancelAccountForm">
    <mat-form-field class="w-all mt-15 px-8">
      <mat-label>{{ 'MODAL_CANCEL_ACC.SELECT' | translate}}</mat-label>
      <mat-select class="select-padding" formControlName="reason">
        <mat-option *ngFor="let reason of reasons" [value]="reason.id"> {{ reason.value }} </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
